/**
 * 📅 Last Modified: 04 Feb, 2023
 */
import React from 'react';
import Button from '../../components/ui/button';

export default function VideoStart({ startHandler }) {
  const btnHandler = () => {
    startHandler();
    // navigate('/get-started');
  };
  return (
    <section className="p-10 max-w-md mx-auto mt-20">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl text-cblack font-semibold mb-4 text-center text-cblue-500">
          Passons à ta vidéo...
        </h1>
      </div>
      <p className="-ml-1 mb-4 text-cred-300">
        <strong>Important :</strong> Toutes les vidéos doivent être en format portrait ! Si la prise
        est en format paysage, elle sera recadrée en format portrait.
      </p>
      <div className="mb-4">
        <b>Trimming, miniatures et titres :</b> Il est possible de couper (trimming) les premières
        ou dernières secondes de la vidéo avant de la télécharger. Sur le site web les vidéos seront
        illustrées par des miniatures titrées.
      </div>
      <div className="mb-4">
        <strong>Notez pour l’enregistrement :</strong>
      </div>
      <div className="pl-2 mb-12">
        <ul className="list-disc">
          <li className="mb-4">
            Enregistrez des <strong>vidéos courtes </strong> (au maximum une minute). Il est
            possible de couper les premières ou dernières secondes de la vidéo avant de la
            télécharger.
          </li>
          <li className="mb-4">
            <strong>L’audio : </strong>
            Pour faire passer un message, parlez à haute voix et faites attention aux bruits de
            fond.
          </li>
          <li className="mb-4">
            <strong>Les prises : </strong>
            Les prises peuvent être répétées.
          </li>
        </ul>
      </div>
      <div className="mb-12">
        <p>
          <strong>Téléchargement : </strong>
          Une fois la vidéo enregistrée, elle sera automatiquement téléchargée sur la page internet
          de votre équipe régionale. Vous puvez échanger la vidéo en répétant ce processus.
        </p>
      </div>
      <div
        className={`flex items-center justify-center fixed bottom-0 bg-white left-0 right-0 border-t border-black py-6`}>
        <Button.ButtonRounded
          className="ml-2 bg-cblue-500 text-white rounded-xl text-xl py-3 px-4"
          onClick={btnHandler}
          type="submit">
          Continuer
        </Button.ButtonRounded>
      </div>
    </section>
  );
}
